const COLOR_KEYWORDS = new Set(['currentcolor', 'inherit', 'initial', 'transparent', 'unset'])

const LENGTH_KEYWORDS = new Set(['inherit', 'initial', 'normal', 'unset'])

const HEX = /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i
const RGB = /^rgba?\(\s*[\d.]+%?\s*(?:,\s*[\d.]+%?\s*){2,3}\)$/i
const HSL = /^hsla?\(\s*[\d.]+(?:deg)?\s*,\s*[\d.]+%\s*,\s*[\d.]+%\s*(?:,\s*[\d.]+%?\s*)?\)$/i
const LENGTH = /^-?(?:\d+\.?\d*|\.\d+)(?:px|rem|em|%)?$/
const NUMBER = /^-?(?:\d+\.?\d*|\.\d+)$/
const UNSAFE_IDENTIFIER = /[^a-z0-9_-]/gi
const UNSAFE_FONT_FAMILY = /[^a-z0-9 _-]/gi

export const sanitizeCssColor = (value?: string | null): string => {
  const clean = (value ?? '').trim()
  if (!clean) return ''
  if (COLOR_KEYWORDS.has(clean.toLowerCase())) return clean
  if (HEX.test(clean) || RGB.test(clean) || HSL.test(clean)) return clean
  return ''
}

export const sanitizeCssLength = (value?: string | number | null): string => {
  if (value === null || value === undefined) return ''
  const clean = String(value).trim()
  if (!clean) return ''
  if (LENGTH_KEYWORDS.has(clean.toLowerCase())) return clean
  return LENGTH.test(clean) ? clean : ''
}

export const sanitizeCssNumber = (value?: string | number | null): string => {
  if (value === null || value === undefined) return ''
  const clean = String(value).trim()
  return NUMBER.test(clean) ? clean : ''
}

export const sanitizeCssIdentifier = (value?: string | null): string =>
  (value ?? '').replace(UNSAFE_IDENTIFIER, '')

export const sanitizeFontFamily = (value?: string | null): string =>
  (value ?? '').replace(UNSAFE_FONT_FAMILY, '').trim()
